<template>
  <div v-if="!isMobile" class="pc-footer-container">
    <div class="inner-container">
      <div class="public-content">
        <div class="nav-list-item">
          <div class="nav-item">
            <img src="../assets/pc-images/footer-nav-1-icon.png" class="icon" />
            行业领先 品类丰富
          </div>
          <div class="nav-item">
            <img src="../assets/pc-images/footer-nav-2-icon.png" class="icon" />
            价格实惠 权益保障
          </div>
          <div class="nav-item">
            <img src="../assets/pc-images/footer-nav-3-icon.png" class="icon" />
            官方流量 安全稳定
          </div>
          <div class="nav-item">
            <img src="../assets/pc-images/footer-nav-4-icon.png" class="icon" />
            7X24小时 售后服务
          </div>
        </div>
        <div class="copyright-item">版权所有: {{ websiteInfo.SiteBqsy  }} {{ websiteInfo.SiteIcp }}</div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'PcFooterComponent',
  computed: {
    ...mapState(['websiteInfo'])
  },
  data() {
    return {
      isMobile: true
    }
  },
  mounted() {
    this.isMobile = this.$TOOL.isMobile
  }
}
</script>

<style scoped lang="less">
.pc-footer-container {
  width: 100%;
  height: 190px;
  .inner-container {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 190px;
    background-color: #131314;
    color: #a1a8b4;
  }
  .public-content {
    position: relative;
    width: 905px;
    margin: 0 auto;
  }
  .nav-list-item {
    padding-top: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .nav-item {
      display: flex;
      align-items: center;
      .icon {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
    }
  }
  .copyright-item {
    margin-top: 35px;
    text-align: center;
    font-size: 16px;
  }
}
</style>